import { createInstance } from 'guppy.ts';

const API_BASE_URL = '/guppy';
export const guppy = createInstance({ url: API_BASE_URL });
